import { Layers } from "lucide-react";
import { Carte, COL, Indisponible, Ligne, Valeur, dateFr, isErreur, nombre } from "./shared";

const ANALYSE = [["ph_eau", "pH eau"], ["ph_kcl", "pH KCl"], ["mo", "MO"], ["n", "N"], ["p_olsen", "P Olsen"], ["k", "K"],
  ["ca", "Ca"], ["mg", "Mg"], ["cec", "CEC"], ["cn", "C/N"]];

export default function SolCard({ data }) {
  const a = !isErreur(data) && data.derniere_analyse;
  return (
    <Carte titre="Sol et milieu" numero="4" icon={Layers} testId="fiche-sol">
      {isErreur(data) ? <Indisponible /> : (
        <>
          <Ligne label="Type de sol" v={data.type_sol} />
          <Ligne label="Climat" v={data.climat} />
          <Ligne label="Pluviométrie" v={data.pluviometrie} />
          <Ligne label="Température moyenne" v={data.temperature} />
          <Ligne label="Irrigation" v={data.irrigation}
            format={(i) => [i.mode, i.source_eau, i.dose ? `${nombre(i.dose)} ${i.unite_dose || ""}`.trim() : null].filter(Boolean).join(" · ")} />
          <Ligne label="Drainage" v={data.drainage} />
          <Ligne label="Dernier calcul AMENDA" v={data.amenda}
            format={(m) => [m.culture, m.rendement_souhaite_t_ha ? `${nombre(m.rendement_souhaite_t_ha)} t/ha visées` : null].filter(Boolean).join(" · ")} />
          <div className="pt-3">
            <div className="text-sm font-semibold mb-1" style={{ color: COL.text }}>Dernière analyse de sol</div>
            {a ? (
              <>
                <p className="text-xs text-gray-500 mb-2">
                  {dateFr(a.date)}{a.laboratoire ? ` · ${a.laboratoire}` : ""}
                  {a.anciennete_mois != null ? ` · il y a ${a.anciennete_mois < 12 ? `${a.anciennete_mois} mois` : `${Math.floor(a.anciennete_mois / 12)} an(s)`}` : ""}
                </p>
                <div className="grid grid-cols-2 gap-x-4">
                  {ANALYSE.filter(([k]) => a[k]).map(([k, l]) => (
                    <div key={k} className="flex justify-between py-1 text-sm border-b" style={{ borderColor: COL.line }}>
                      <span style={{ color: COL.muted }}>{l}</span>
                      <span className="font-medium">{nombre(a[k].valeur)}{a[k].unite ? ` ${a[k].unite}` : ""}</span>
                    </div>
                  ))}
                </div>
              </>
            ) : <Valeur v={null} />}
          </div>
        </>
      )}
    </Carte>
  );
}
